document.addEventListener('DOMContentLoaded', () => {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      let images = entry.target?.querySelectorAll("img");
      if (entry.isIntersecting) {
        images.forEach(img => img.style.animationPlayState = "running");
      } else {
        images.forEach(img => img.style.animationPlayState = "paused");
      }
    });
  }, { threshold: 0.3 }); // 元素有 30% 出现在视口时触发

  $('.ht-controls-animation').each(function() {
    observer.observe(this);
  });
})